export const en = {
    select: 'Select',
    'zoom-in-button-text': 'Zoom in'
};
